import React, { useState, useContext } from 'react';
import { ChevronLeft, Upload } from 'lucide-react';
import { AppContext } from '../../App';
import { adminAPI } from '../../services/api';
import { toast } from 'react-toastify';

const ImportPayments = () => {
  const { navigate } = useContext(AppContext);
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async () => {
    if (!file) {
      toast.error('Choose an Excel file');
      return;
    }
    setBusy(true);
    setResult(null);
    try {
      const res = await adminAPI.importPaymentsExcel(file);
      setResult(res);
      toast.success('Import finished: ' + (res.imported ?? 0) + ' ok, ' + (res.failed ?? 0) + ' failed');
    } catch (e) {
      toast.error(e.response?.data?.message || 'Import failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="h-full flex flex-col">
      <header className="sticky top-0 z-30 p-6 bg-[#001E3C] flex items-center gap-4 border-b border-white/10">
        <button type="button" onClick={() => navigate('/admin/dashboard')} className="glass-card p-3 rounded-xl">
          <ChevronLeft className="w-5 h-5 text-white" />
        </button>
        <h2 className="text-xl font-black uppercase text-white">Import payments (Excel)</h2>
      </header>
      <div className="flex-1 overflow-y-auto p-6 space-y-6 no-scrollbar text-white">
        <p className="text-xs text-white/60">
          For payments collected outside the system. Use columns such as: <strong>valuation number</strong> (or valuation_no),{' '}
          <strong>amount</strong> (or amount_paid), optional <strong>payment_date</strong>, optional <strong>payer_name</strong>.
          First sheet is read. Rows without valuation and amount are skipped.
        </p>
        <label className="flex flex-col gap-2">
          <span className="text-sm font-bold">Excel file (.xlsx)</span>
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            className="text-sm text-white/80"
          />
        </label>
        <button
          type="button"
          onClick={submit}
          disabled={busy || !file}
          className="w-full py-4 rounded-2xl btn-gold font-black uppercase text-sm flex items-center justify-center gap-2 disabled:opacity-50"
        >
          <Upload className="w-5 h-5" />
          {busy ? 'Uploading...' : 'Upload & import'}
        </button>
        {result && (
          <div className="glass-card p-4 text-sm space-y-2">
            <p>Imported: {result.imported}</p>
            <p>Failed: {result.failed}</p>
            {result.errors?.length > 0 && (
              <ul className="text-xs text-amber-200/90 max-h-40 overflow-y-auto list-disc pl-4">
                {result.errors.map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImportPayments;
